// extracted by mini-css-extract-plugin
export default {"cookiehead":"cookiehead_cookiehead__0Zf9q"};